module.exports = __webpack_public_path__ + "img/kcardBg.05a8f14.png";